var _Header_instances, _Header_language, _Header_hasLoadedStrings, _Header_logout, _Header_clickEnglish, _Header_clickFrench;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import "@vaadin/button";
import "@vaadin/horizontal-layout";
import "@vaadin/tabs";
import { css, html, LitElement } from "lit";
import { registerTranslateConfig, translate, use } from "lit-translate";
import { connect } from "pwa-helpers";
import { logoutAction, selectLanguage, selectToken, store, useEnglish, useFrench, } from "./Store.js";
import { validateToken } from "./utils/AuthenticationUtils.js";
import { getAllAwards } from "./utils/AwardUtils.js";
export class Header extends connect(store)(LitElement) {
    constructor() {
        super(...arguments);
        _Header_instances.add(this);
        _Header_language.set(this, "en");
        _Header_hasLoadedStrings.set(this, false);
        this.devBannerElement = html `<div id="banner">
    <div id="banner-content">
      This is the CSP development site. Changes here will not be reflected in
      the production site, and data integrity is not guaranteed.
    </div>
  </div>`;
        _Header_logout.set(this, () => {
            store.dispatch(logoutAction());
            window.location.href = "index.html";
        });
    }
    shouldUpdate(changedProperties) {
        const parent = super.shouldUpdate(changedProperties);
        console.log(`Parent=${parent} hasLoadedStrings=${__classPrivateFieldGet(this, _Header_hasLoadedStrings, "f")}`);
        return __classPrivateFieldGet(this, _Header_hasLoadedStrings, "f") && parent;
    }
    // loads the initial language and marks that the strings have been loaded
    async connectedCallback() {
        super.connectedCallback();
        // Pull language from query params
        const params = new URLSearchParams(window.location.search);
        const lang = params.get("lang");
        if (lang) {
            if (lang === "en") {
                store.dispatch(useEnglish());
            }
            else if (lang === "fr") {
                store.dispatch(useFrench());
            }
            params.delete("lang");
        }
        // set the language default
        __classPrivateFieldSet(this, _Header_language, selectLanguage(store.getState()), "f");
        // load awards cache
        await getAllAwards()
            // set app language
            .then(() => use(__classPrivateFieldGet(this, _Header_language, "f")));
        __classPrivateFieldSet(this, _Header_hasLoadedStrings, true, "f");
        if (__classPrivateFieldGet(this, _Header_language, "f") === "en")
            store.dispatch({ type: "ENGLISH" });
        else
            store.dispatch({ type: "FRENCH" });
        this.requestUpdate();
    }
    render() {
        const selectedString = __classPrivateFieldGet(this, _Header_language, "f") === "en" ? "0" : "1";
        if (!["", "/", "/index", "/index.html"].includes(window.location.pathname)) {
            // login page
            validateToken();
        }
        return html ` ${process.env.APP_ENV !== "production"
            ? this.devBannerElement
            : undefined}
      <vaadin-horizontal-layout
        theme="spacing padding"
        style="align-items: start; justify-content: space-evenly"
      >
        ${selectToken(store.getState())
            ? html ` <div class="LeftSide">
              <vaadin-button
                @click=${() => (window.location.href = "index.html")}
                >${translate("header.home")}
              </vaadin-button>
              <vaadin-button @click=${__classPrivateFieldGet(this, _Header_logout, "f")}
                >${translate("header.logout")}
              </vaadin-button>
            </div>`
            : html `<div></div>`}
        <vaadin-horizontal-layout
          theme="spacing padding"
          style="align-items: center"
        >
          <img
            alt="Canadian Ski Patrol Logo"
            src="assets/Logo_for_Canadian_Ski_Patrol.jpg"
          />
          <h2>${translate("header.title")}</h2>
        </vaadin-horizontal-layout>
        <vaadin-tabs selected="${selectedString}">
          <vaadin-tab @click=${__classPrivateFieldGet(this, _Header_instances, "m", _Header_clickEnglish)}
            >${translate("header.langEn")}
          </vaadin-tab>
          <vaadin-tab @click=${__classPrivateFieldGet(this, _Header_instances, "m", _Header_clickFrench)}
            >${translate("header.langFr")}
          </vaadin-tab>
        </vaadin-tabs>
      </vaadin-horizontal-layout>`;
    }
}
_Header_language = new WeakMap(), _Header_hasLoadedStrings = new WeakMap(), _Header_logout = new WeakMap(), _Header_instances = new WeakSet(), _Header_clickEnglish = async function _Header_clickEnglish() {
    store.dispatch(useEnglish());
    await use("en").then();
    this.requestUpdate();
}, _Header_clickFrench = async function _Header_clickFrench() {
    store.dispatch(useFrench());
    await use("fr").then();
    this.requestUpdate();
};
Header.styles = css `
    :host {
      vertical-align: center;
      font-size: calc(10px + 1vmin);
      min-height: 100px;
      height: auto;
      margin: 0 auto;
      text-align: center;
      // background-color: #DC0000;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    .LanguageSwitch {
      display: flex;
      width: 100%;
    }

    .border10 {
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .Center {
      align: center;
      width: 100%;
    }

    .LeftSide {
      align: left;
      width: 20%;
    }

    .RightSide {
      float: right;
      width: 20%;
    }

    .CenterSpace {
      align: center;
      width: 60%;
    }

    div#banner {
      top: 0;
      left: 0;
      background-color: #de4b0f;
      width: 100%;
    }

    div#banner-content {
      margin: 0 auto;
      padding: 5px;
    }

    div#main-content {
      padding-top: 35px;
    }
  `;
registerTranslateConfig({
    loader: lang => fetch(`/assets/i18n/${lang}.json`).then(res => res.json()),
});
customElements.define("app-header", Header);
//# sourceMappingURL=Header.js.map